module.exports = __webpack_public_path__ + "static/media/BrownDesperado.e9615eee.jpg";